import { Component, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'apc-navbar-small',
  templateUrl: './navbar-small.component.html',
  styleUrls: ['./navbar-small.component.scss'],
})
export class NavbarSmallComponent implements AfterViewInit {
  @Input() public items: any[];
  @Input() public color: string;
  @Input() public permission: string;
  @Input() public notFlexMenu: boolean = false;
  @Input() public changeViewOption: boolean = false;
  @Output() changeViewEvent = new EventEmitter<boolean>(false);

  public isScrolled = false;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    if (!window.location.href.includes('/administration/')) {
      let elementHead = document.getElementById('navbar-small');
      if (window.pageYOffset > 185) {
        elementHead.classList.add('menu-scrolled');
        this.isScrolled = true;
      } else {
        elementHead.classList.remove('menu-scrolled');
        this.isScrolled = false;
      }
    }
  }

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngAfterViewInit() {
    var navbar = document.getElementById('navbar-small');
    var menus = navbar.getElementsByTagName('a');
    /*     if (menus.length == 1 && !window.location.pathname.split('/')[4]) {
          menus[0].click();
        } */
    if (menus.length > 0) {
      let url = this.router.url;
      let found = false;
      for (let i = 0; i < menus.length && !found; i++) {
        if (menus[i].href.endsWith(url)) {
          found = true;
        }
      }
      if (!found && url?.split("/")?.length <=3) {
        let href = menus[0].href.split('/');
        let lastPath = href[href.length - 1];
        this.router.navigate([lastPath], { relativeTo: this.route });
      }
    }
  }

}
